import addPublicFolderToStore from '../actions/addPublicFolderToStore';
import { mutator } from 'satcheljs';

export default mutator(addPublicFolderToStore, actionMessage => {
    const { state, item } = actionMessage;
    let folderId = item.id;

    if (!state.folderTable.has(folderId)) {
        state.folderTable.set(folderId, item);
    }
});
